// extracted by mini-css-extract-plugin
export default {"pageSection":"PageSection_pageSection__vYTqZ"};